import { contentBlockSurface } from 'shared/assets/styles';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100dvh;
  width: 100%;
  padding-right: ${({ theme }) => theme.spacing(0.5)};

  overflow: auto;
`;

export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};

  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(1.5)} ${theme.spacing(2)} ${theme.spacing(2)}`};
  min-width: 0;
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${contentBlockSurface};

  overflow: hidden;
`;
